import { cn } from "@/lib/utils";

interface PaginationDotsProps {
  total: number;
  current: number;
  onDotClick: (index: number) => void;
  activeClassName?: string;
  inactiveClassName?: string;
  variant?: "light" | "dark";
}

export function PaginationDots({
  total,
  current,
  onDotClick,
  activeClassName = "w-8 bg-[#FFEDEB]",
  inactiveClassName = "w-3 bg-[#FFEDEB] rounded-md",
  variant = "light",
}: PaginationDotsProps) {
  return (
    <div className="w-full flex items-center justify-center mt-4 gap-2">
      {Array.from({ length: total }).map((_, index) => (
        <div key={index}>
          <button
            className="lg:flex hidden items-center justify-center size-6 -my-1.5"
            onClick={() => onDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
          >
            <span
              aria-hidden="true"
              className={cn(
                `h-3 rounded-[20px] transition-all`,
                ` ${index === current ? activeClassName : inactiveClassName}`,
                {
                  "bg-primary": variant === "light" && index == current,
                }
              )}
            />
          </button>
          <button
            className="lg:hidden flex items-center justify-center size-6 -my-1.5"
            onClick={() => onDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
          >
            <span
              aria-hidden="true"
              className={cn(
                `h-3 rounded-[20px] transition-all`,
                ` ${index === current ? activeClassName : inactiveClassName}`,
                {
                  "bg-primary": variant === "light" && index == current,
                }
              )}
            />
          </button>
        </div>
      ))}
    </div>
  );
}
